<script>

import Vue from 'vue'
//import api from "../../../../plugins/api";
import { getDocumentos } from "../../../../store/livro-digital/documentos-repository";





export default Vue.extend({
    props: {
        codigo_condominio: {
            type: Number,
            required: true
        },
        codigo_livro_digital: {
            type: Number,
            required: true
        },
        id_docsprime: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            documentos: [],
            loading: false
        }
    },
    methods: {
        async loadDocumentos() {
            this.loading = true
            try {
                const documentos = await  getDocumentos({
                    codigo_condominio: this.codigo_condominio,
                    codigo_livro_digital: this.codigo_livro_digital,
                    id_docsprime: this.id_docsprime
                })
                
                this.documentos = documentos

            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
       this.loadDocumentos()
    },
    render() {
        return this.$scopedSlots.default({
            loading: this.loading,
            documentos: this.documentos
        })
    }
})

</script>